<script>
    import {_, locale, number} from 'svelte-i18n';
    import {gameConfig} from "../../stores.js";
    import Item from './Item.svelte';

    let { item, bonus, goldAmount: goldAmountProp, itemsAmount } = $props();
    let itemDetails = $state({});

    let goldAmount = $derived(goldAmountProp === 0 ? $gameConfig?.gameItems?.[item?.id]?.goldValue ?? 0 : goldAmountProp);

    function getRarity() {
        let itemRarity = 1;

        if (goldAmount > 100 && goldAmount < 2000) {
            itemRarity = 2;
        } else if (goldAmount >= 1200 && goldAmount <= 7500) {
            itemRarity = 3;
        } else if (goldAmount >= 7500) {
            itemRarity = 4;
        }

        return itemRarity;
    }

    function setItemDetails() {
        itemDetails.title = bonus ? $number(goldAmount) + ' ' + $_('Gold') + ' (' + $_('Bonus') + ')' : $number(goldAmount) + ' ' + $_('Gold');
        itemDetails.description =
            bonus ? $_('PacksReceiveGold') + ' ' + $number(goldAmount) + ' ' + $_('Bonus') + ' ' + $_('Gold') : $_('PacksReceiveGold') + ' ' + $number(goldAmount) + ' ' + $_('Gold');
        itemDetails.amount = itemsAmount;
        itemDetails.icon = 'gold_l';
        itemDetails.rarity = getRarity();
        itemDetails.claimed = item.claimed;
    }

    $effect(() => {
        $locale;
        setItemDetails();
    });
</script>

<Item {itemDetails}/>
